import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BcbChartYear, BcbPolicyDecision} from './bcb.models';

interface BcbRateMonth {
  label: string;
  rate: number | null;
  change: number | null;
  date: string;
  extraordinary: boolean;
}

@Component({
  selector: 'app-bcb-rate-table',
  standalone: true,
  templateUrl: './bcb-rate-table.component.html',
  styleUrl: './bcb-rate-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BcbRateTableComponent {
  @Input({required: true}) row!: BcbChartYear;

  private readonly labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  get months(): BcbRateMonth[] {
    const decisions = [...this.row.policyDecisions].sort((a, b) => a.date.localeCompare(b.date));
    let rate = decisions[0]?.previousRate ?? null;

    return this.labels.map((label, monthIndex) => {
      const inMonth = decisions.filter((decision) => Number(decision.date.slice(5, 7)) === monthIndex + 1);
      if (inMonth.length) rate = inMonth[inMonth.length - 1].rate;
      const moves = inMonth.filter((decision) => decision.changePoints !== null);
      const change = moves.length
        ? Number(moves.reduce((sum, decision) => sum + (decision.changePoints ?? 0), 0).toFixed(4))
        : null;
      return {
        label,
        rate,
        change,
        date: this.dateLabel(inMonth),
        extraordinary: inMonth.some((decision) => decision.extraordinary),
      };
    });
  }

  changeLabel(change: number | null): string {
    if (change === null) return '';
    if (change === 0) return '0';
    return `${change > 0 ? '+' : '−'}${Math.abs(change)} pp`;
  }

  private dateLabel(decisions: BcbPolicyDecision[]): string {
    if (!decisions.length) return '';
    const first = `${this.labels[Number(decisions[0].date.slice(5, 7)) - 1]} ${Number(decisions[0].date.slice(8, 10))}`;
    return decisions.length > 1 ? `${first}+${decisions.length - 1}` : first;
  }
}
